import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import ArrowLink from "../molecules/ArrowLink";
export default function FourColBlocks(props) {
    var _props_col;
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative page-container-lg mb-12 md:my-20"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl relative"
    }, props.blockHeading && /*#__PURE__*/ React.createElement("div", {
        className: "mb-8 md:mb-12 lg:mb-20"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "mx-auto mb-3 text-center font-medium max-w-xs md:max-w-md lg:max-w-lg block text-2xl md:text-3xl lg:text-4xl"
    }, props.blockHeading)), /*#__PURE__*/ React.createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "grid max-[767px]:grid-cols-1 max-[1023px]:grid-cols-2 lg:flex lg:flex-wrap gap-8"
    }, (_props_col = props.col) === null || _props_col === void 0 ? void 0 : _props_col.map(function(col, index) {
        var _col_ctas;
        /*#__PURE__*/ return React.createElement("div", {
            key: index,
            className: "flex flex-col flex-1 justify-between border bg-white overflow-hidden max-[1023px]:rounded-l-3xl lg:first:rounded-l-3xl lg:last:rounded-r-3xl"
        }, /*#__PURE__*/ React.createElement("div", {
            className: clsx("flex flex-col justify-between h-full gap-y-2 pt-6 px-6 pb-7 min-h-[190px] lg:min-h-0 border-t-8", {
                "border-t-gray-400": (col === null || col === void 0 ? void 0 : col.color) === "gray",
                "border-t-yellow-500": (col === null || col === void 0 ? void 0 : col.color) === "yellow",
                "border-t-orange-500": (col === null || col === void 0 ? void 0 : col.color) === "orange",
                "border-t-blue-500": (col === null || col === void 0 ? void 0 : col.color) === "blue"
            })
        }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h3", {
            className: "font-medium text-xl md:text-2xl mb-1.5"
        }, col === null || col === void 0 ? void 0 : col.title), (col === null || col === void 0 ? void 0 : col.subtitle) && /*#__PURE__*/ React.createElement("span", {
            className: "text-gray-200 block mb-4 md:mb-6"
        }, col === null || col === void 0 ? void 0 : col.subtitle), (col === null || col === void 0 ? void 0 : col.content) && /*#__PURE__*/ React.createElement("div", {
            className: "content-text content-text-sm text-sm"
        }, (col === null || col === void 0 ? void 0 : col.contentHeading) && /*#__PURE__*/ React.createElement("h4", {
            className: "font-semibold mb-2.5 text-base"
        }, col.contentHeading), /*#__PURE__*/ React.createElement(Html, {
            markup: col === null || col === void 0 ? void 0 : col.content
        }))), (col === null || col === void 0 ? void 0 : col.ctas) && /*#__PURE__*/ React.createElement("div", null, col === null || col === void 0 ? void 0 : (_col_ctas = col.ctas) === null || _col_ctas === void 0 ? void 0 : _col_ctas.map(function(cta, key) {
            /*#__PURE__*/ return React.createElement("a", {
                key: key,
                href: cta === null || cta === void 0 ? void 0 : cta.target,
                className: clsx("w-full mb-4 last:mb-0 cursor-pointer", {
                    "button-secondary px-4 focus bg-white border-gray-600 text-gray-600 hover:bg-orange-500 hover:border-orange-500 hover:text-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "PRIMARY",
                    "button-secondary px-4 border-gray-600 text-white bg-gray-600 hover:text-gray-600 hover:bg-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "SECONDARY",
                    "text-gray-600 font-bold underline font-heading": (cta === null || cta === void 0 ? void 0 : cta.display) === "PLAIN"
                })
            }, cta === null || cta === void 0 ? void 0 : cta.label);
        }))), (col === null || col === void 0 ? void 0 : col.linkUrl) && /*#__PURE__*/ React.createElement("div", {
            className: "px-6 pt-3.5 pb-4 bg-gray-30 mt-1"
        }, /*#__PURE__*/ React.createElement(ArrowLink, {
            text: (col === null || col === void 0 ? void 0 : col.linkText) || "Learn more",
            target: (col === null || col === void 0 ? void 0 : col.linkUrl) || "/"
        })));
    }))))));
}
